export default "__VITE_ASSET__1bbad434__"